<template>
  <div class="icp">
    <img :src="ICPImage" alt="ICP" />
    {{ icp }}
  </div>
</template>

<script>
import ICPImage from '@/assets/img/icp.png';
import {ICP} from '@/constant/env.js';

export default {
  data() {
    return {
      icp: ICP,
      ICPImage,
    };
  },
};
</script>

<style lang="scss" scoped>
.icp {
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  margin-top: 16px;
  margin-bottom: 16px;
  // position: absolute;
  // bottom: calc(8px + env(safe-area-inset-bottom));
  // width: 100%;
  // text-align: center;
  //
  // opacity: 0.5;
  // z-index: 1010;
  img {
    width: 16.2px;
  }
}
</style>
